import { ActiveAccount } from "@/redux/activeAccount/activeAccount.slice";
import { UserRoles } from "@/types/user.type";

import ListIcon from "@/assets/icons-mono/list.svg?react";
import NotesIcon from "@/assets/icons-mono/notes.svg?react";
import DotsIcon from "@/assets/icons-mono/dots.svg?react";
import DashboardIcon from "@/assets/icons-mono/dashboard.svg?react";
import Sensor1Icon from "@/assets/icons-mono/sensor1.svg?react";
import SettingsIcon from "@/assets/icons-mono/settings.svg?react";
import { LuDot } from "react-icons/lu";
import { Feature } from "@/constants/Feature.constant";
import { FeaturePermission } from "@/constants/Permission.constant";

export type SidebarRoute = {
  id: string;
  translation: string;
  permissions: (UserRoles | "*")[];
  dropdownParent?: string;
  Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  path?: string;
  children?: SidebarRoute[];
};

export const getFeatureIcon = (
  feature: (typeof Feature)[keyof typeof Feature]
) => {
  switch (feature) {
    case Feature.ADMIN:
      return SettingsIcon;
    case Feature.BROWSE:
      return ListIcon;
    case Feature.DASHBOARD:
      return DashboardIcon;
    case Feature.STOCK_MANAGEMENT:
      return Sensor1Icon;
    case Feature.PROJECT_ADMIN:
      return NotesIcon;
    case Feature.REPORTS:
      return DotsIcon;
    case Feature.LOGS:
      return DotsIcon;
    default:
      return LuDot;
  }
};

export const getSidebarRoutes = (
  activeAccount: ActiveAccount | null
): SidebarRoute[] => [
  {
    id: "browseLink",
    translation: "BROWSE",
    path: "/app/browse",
    permissions: FeaturePermission.BROWSE,
    Icon: getFeatureIcon(Feature.BROWSE)
  },
  {
    id: "projectStatusLink",
    translation: "PROJECT_STATUS",
    path: "/app/project-status",
    permissions: FeaturePermission.PROJECT_ADMIN,
    Icon: getFeatureIcon(Feature.PROJECT_ADMIN)
  },
  {
    id: "dashboardLink",
    translation: Feature.DASHBOARD,
    path: activeAccount
      ? `/app/dashboard?${
          activeAccount.type === "partner"
            ? "partner=" +
              activeAccount.id.toString() +
              "&partner-name=" +
              encodeURIComponent(activeAccount.name)
            : "company=" +
              activeAccount.id.toString() +
              "&company-name=" +
              encodeURIComponent(activeAccount.name)
        }`
      : "/app/dashboard",
    permissions: FeaturePermission.DASHBOARD,
    Icon: getFeatureIcon(Feature.DASHBOARD)
  },
  {
    id: "stockManagement",
    translation: Feature.STOCK_MANAGEMENT,
    permissions: FeaturePermission.STOCK_MANAGEMENT,
    Icon: Sensor1Icon,
    path: "/app/sensor-management"

    // children: [
    //   {
    //     id: "sensorManagementLink",
    //     translation: "SENSOR_MANAGEMENT",
    //     path: "/app/sensor-management",
    //     permissions: FeaturePermission.STOCK_MANAGEMENT,
    //     Icon: LuDot
    //   },
    //   {
    //     id: "relayManagementLink",
    //     translation: "RELAY_MANAGEMENT",
    //     path: "/app/relay-management",
    //     permissions: FeaturePermission.STOCK_MANAGEMENT,
    //     Icon: LuDot
    //   }
    // ]
  },
  // {
  //   id: 'deliveryPerformanceSensorTechnicianLink',
  //   translation: 'DELIVERY_PERFORMANCE_ST',
  //   path: '/app/delivery-performance-sensor-technician',
  //   permissions: ['*'],
  // },
  // {
  //   id: 'deliveryPerformanceLELink',
  //   translation: 'DELIVERY_PERFORMANCE_LE',
  //   path: '/app/delivery-performance-le',
  //   permissions: ['*'],
  // },
  {
    id: "userManagementLink",
    translation: Feature.ADMIN,
    path: "/app/user-management",
    permissions: FeaturePermission.ADMIN,
    Icon: getFeatureIcon(Feature.ADMIN)
  },
  // {
  //   id: "projectAdmin",
  //   translation: "PROJECT_ADMIN",
  //   path: "/app/admin/project",
  //   permissions: [UserRoles.SUPER_ADMIN]
  // },
  // {
  //   id: "gisAdminLink",
  //   translation: "GIS_ADMIN",
  //   path: "/app/gis-admin",
  //   permissions: [UserRoles.SUPER_ADMIN]
  // },

  // {
  //   id: "reportsLink",
  //   translation: Feature.REPORTS,
  //   path: "/app/reports",
  //   permissions: [
  //     UserRoles.SUPER_ADMIN,
  //     UserRoles.PARTNER_ADMIN,
  //     UserRoles.COMPANY_ADMIN
  //   ],
  //   Icon: DotsIcon
  // },

  // {
  //   id: "gisUploadLink",
  //   translation: "GIS_UPLOAD",
  //   path: "/app/gis-upload",
  //   permissions: [UserRoles.SUPER_ADMIN]
  // },

  {
    id: "logsLink",
    translation: Feature.LOGS,
    path: "/app/logs",
    permissions: FeaturePermission.LOGS,
    Icon: getFeatureIcon(Feature.LOGS)
  }
];
